class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations();
  }

  loadRecommendations() {
    if (!this.dataset.url || this.dataset.loading === 'true' || this.dataset.loaded === 'true') return;
    this.dataset.loading = 'true';

    fetch(this.dataset.url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' }
    })
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          this.hidden = true;
        }
        this.dataset.loaded = 'true';
      })
      .catch(e => {
        console.error(e);
        this.hidden = true;
      })
      .finally(() => {
        delete this.dataset.loading;
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
